import { Box, Chip } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';

const PlannelFooter = (props) => {
  const paramSx = props?.sx;
  return (
    <Box sx={{width : "100%", display: "inline-flex", flexDirection: "column", ...paramSx}} variant="body2" color="text.secondary" align="center">
      <Box sx={{width : "100%", display: "inline-flex", flexDirection: "row", justifyContent: "space-between", ...paramSx}} variant="body2" color="text.secondary" align="center">
        <SshSeal/>
        <Status/>
      </Box>
      <Box sx={{width: "100%", mt: 1}}>
        <Copyright/>
      </Box>
    </Box>
  );
}

const SshSeal = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://seal.godaddy.com/getSeal?sealID=CcKlBBzDnjkf15luIgwoIx4eZ5Can6rIGUPpkvdUoi3i9g9McHfXYvlSRmpp';
    script.async = true;

    const sitesealElement = document.getElementById('siteseal');
    if (sitesealElement) {
      sitesealElement.appendChild(script);
    }

    return () => {
      const el = document.getElementById('siteseal');
      if (el && el.contains(script)) {
        el.removeChild(script);  
      }
    };
  }, []); 

  return (
  <Box width={"auto"} display="flex" flexDirection="column" justifyContent="center">
    <span id="siteseal"/>
  </Box>
  );
}

const Copyright = () => {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" pl={0.5}>
      <Typography width={"auto"} variant="body2" color="text.secondary" align="center" sx={{alignSelf:"center"}}>
        {'Copyright © '}
        <a target="_blank" href="https://zionex.com/plannel/" rel="noopener noreferrer">Zionex</a>
        {' '}
        {new ZDate().getFullYear()}
        {'.'}
      </Typography>
    </Box>
  );
}

const Status = () => {
  return (
    <Box display="flex" flexDirection="column" justifyContent="center" pl={'75px'}>
      <Typography variant="body2" color="text.secondary" align="center" component={"span"}>
        <a target="_blank" href="http://status.plannel.ai/" rel="noopener noreferrer">
          <Chip clickable size={"small"} label="Status" color="primary"/>
        </a>
      </Typography>
    </Box>
  )
}


export default PlannelFooter;